// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import { kpiSelectorMapping } from '../geminiConst';

type Props = {
  text: string,
  isSelected: string,
  onClick: () => void,
  selectedKpi: string,
  subKpiSelected: string,
  setSubKpi: (string) => void,
}

function ChartFilterSelector({
  text, isSelected, onClick, selectedKpi, subKpiSelected, setSubKpi,
}: Props) {
  const updateSelectedSubKpi = (subKpi: string, event: Event) => {
    event.stopPropagation();
    setSubKpi(subKpi);
  };

  const hasMultipleSubKpi = () => kpiSelectorMapping[selectedKpi].kpis.length > 1;

  return (
    <div
      className={`kpi-filter ${isSelected ? 'selected' : 'not-selected'} ${!hasMultipleSubKpi() ? 'unique-kpi' : ''}`}
      onClick={onClick}
      role="button"
    >
      {
        hasMultipleSubKpi()
        && <i className={`kpi-filter-chevron ${isSelected ? 'fa fa-chevron-down' : 'fa fa-chevron-right'}`} />
      }
      {text}
      <div className="content">
        {
          (hasMultipleSubKpi() && isSelected) && (
            kpiSelectorMapping[selectedKpi].kpis.map(kpi => (
              <button
                key={kpi}
                className={`sub-kpi ${subKpiSelected === kpi ? 'selected' : ''}`}
                onClick={event => updateSelectedSubKpi(kpi, event)}
              >
                <Translate value={`GEMINI.KPI.${kpi}`} />
              </button>
            ))
          )
        }
      </div>
    </div>
  );
}

export default ChartFilterSelector;
